import React, { useEffect } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import format from "date-fns/format";

import * as actions from "../../../../store/actions";

import {
  REMOVE_VALIDATIONS,
  VALIDATE_TEMPLATE,
} from "../../../../store/actions/actionTypes";

import CustomTextArea from "../../../../components/formElements/customTextArea/CustomTextArea";
import LoadingSpinner from "../../../../components/uiElements/loadingSpinner/LoadingSpinner";
import ProfileIcon from "../../../../components/uiElements/icons/profileIcons/ProfileIcon";
import Row from "../../../../components/uiElements/grid/Row";
import Col from "../../../../components/uiElements/grid/Col";

const LockNotes = ({
  form,
  templates,
  setTemplateData,
  getTemplateById,
  validateData,
  currentId,
  appendImageinNotes,
  images,
  apiUtil,
  removeScreenshot,
  ongoingAppointment,
}) => {
  const id = currentId;

  useEffect(() => {
    const cureTemplate = { ...templates };

    const { notesImages, ...template } = cureTemplate;

    Object.keys(template)?.length === 0 && getTemplateById(id);

    // eslint-disable-next-line
  }, [currentId]);

  useEffect(() => {
    validateData(templates);
  }, [templates, validateData]);

  useEffect(() => {
    images?.length > 0 && images?.forEach(image => appendImageinNotes(image));

    // eslint-disable-next-line
  }, [images]);

  if (apiUtil.isLoading) {
    return (
      <div className="center-content">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <>
      <div className="w-100  incallnotes">
        <div className="text-center">
          <p>
            <span
              className="col-md-10 pl-5"
              style={{
                color: "#828282",
                fontWeight: "normal",
              }}
            >
              {format(
                new Date(new Date()),
                "MMMM dd, yyyy"
              )}{" "}
            </span>
          </p>
        </div>

        <div className={classnames("col-md-12 incallnotes mt-4")}>
          <div>
            <span>Note Name</span>
            <CustomTextArea
              value={templates.note_name || ""}
              error={form.note_name}
              onChange={val => setTemplateData({ note_name: val })}
            />
          </div>
          <div>
            <span>Chief Complaint</span>
            <CustomTextArea
              value={templates.chief_complaint || ""}
              error={form.chief_complaint}
              onChange={val => setTemplateData({ chief_complaint: val })}
            />
          </div>
          {ongoingAppointment?.vitals && (
            <div>
              <span>Vitals</span>

              <Row className="ml-0 my-2">
                <Col size={["md-6"]}>
                  <p className=" vital-topic mb-0 pb-0">Blood Pressure</p>
                  <p className="vital-value">
                    {ongoingAppointment?.vitals?.blood_pressure || " - "}
                  </p>
                </Col>

                <Col size={["md-6"]}>
                  <p className=" vital-topic mb-0 pb-0">Pulse</p>
                  <p className="vital-value">
                    {ongoingAppointment?.vitals?.pulse || " - "}
                  </p>
                </Col>
                <Col size={["md-6"]}>
                  <p className=" vital-topic mb-0 pb-0">Oxygen Saturation</p>
                  <p className="vital-value">
                    {ongoingAppointment?.vitals?.oxygen_saturation || " - "}
                  </p>
                </Col>
                <Col size={["md-6"]}>
                  <p className=" vital-topic mb-0 pb-0">Weight</p>
                  <p className="vital-value">
                    {ongoingAppointment?.vitals?.weight || " - "}
                  </p>
                </Col>
                <Col size={["md-6"]}>
                  <p className=" vital-topic mb-0 pb-0">Height</p>
                  <p className="vital-value">
                    {ongoingAppointment?.vitals?.height || " - "}
                  </p>
                </Col>
              </Row>
            </div>
          )}
          <div>
            <span>Notes</span>
            <CustomTextArea
              value={templates?.notes || ""}
              error={form.notes}
              onChange={val => setTemplateData({ notes: val })}
            />
          </div>
          <div>
            {templates?.notesImages?.map((img, i) => (
              <div className="px-2 pb-2">
                <img
                  alt={"loclNotesScreenshots"}
                  src={img}
                  className="screenshots img-fluid"
                />

                <button
                  className="button-style image-delete"
                  onClick={() => removeScreenshot(i)}
                >
                  <ProfileIcon type="delete" />{" "}
                </button>
              </div>
            ))}{" "}
          </div>
          <div>
            <span>Assessment</span>
            <CustomTextArea
              value={templates.assessment || ""}
              error={form.assessment}
              onChange={val => setTemplateData({ assessment: val })}
            />
          </div>
          <div>
            <span>Plan</span>
            <CustomTextArea
              value={templates.plan || ""}
              error={form.plan}
              onChange={val => setTemplateData({ plan: val })}
            />
          </div>
        </div>
      </div>
    </>
  );
};

const mapStoreToProps = ({ dashboard, validation, api }) => ({
  templates: dashboard?.templates?.currentData,
  form: validation.data,
  currentId: dashboard?.templates?.currentId,
  images: dashboard?.templates?.images,
  ongoingAppointment: dashboard?.ongoingAppointment,
  apiUtil: api,
});

const mapDispatchToProps = dispatch => ({
  validateData: templates =>
    dispatch(actions.validateData(VALIDATE_TEMPLATE, templates)),
  getTemplateById: id => dispatch(actions.getTemplateById(id)),
  setTemplateData: Data => dispatch(actions.setTemplateData(Data)),
  clearTemplateData: () => dispatch(actions.clearTemplateData()),
  appendImageinNotes: url => dispatch(actions.appendImageinNotes(url)),
  clearScreenshots: () => dispatch(actions.clearScreenshots()),
  removeValidations: () =>
    dispatch(actions.validateData(REMOVE_VALIDATIONS, {})),
  setViewMode: id => dispatch(actions.setViewMode(id)),
  removeScreenshot: id => dispatch(actions.removeScreenshot(id)),
});

export default connect(mapStoreToProps, mapDispatchToProps)(LockNotes);
